/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Preset_TodayInputs */

const vi_report_preset_today = /** @type {(inputs: Report_Preset_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hôm nay`)
};

/**

* @param {Report_Preset_TodayInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_preset_today = /** @type {((inputs?: Report_Preset_TodayInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Preset_TodayInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_preset_today(inputs)
});